import React from 'react';
import PropTypes from 'prop-types';

const Confirmation = (props) => {
	const { JobEventType } = props;
	return (
		<div className="form-panel panel panel-default text-center">
			<div className="panel-heading text-center">
				<h4 className="panel-title text-primary">{ JobEventType }</h4>
			</div>
			<div className="panel-body container-fluid">
				<div className="row panel-row">
					<div className="col-xs-10 col-xs-offset-1">
						<h2 className="text-primary">Success!</h2>
						<h4>You will soon be contacted by a RollKall Representative.</h4>
					</div>
				</div>
				<div className="row panel-row text-left">
					<div className="col-xs-10 col-xs-offset-1">
						We are excited about this opportunity to connect your business with off-duty police officers.
						Your job will be reviewed by a RollKall Coordinator. We will reach out for additional information
						if necessary. Once the job is created, you will receive an emailed invoice for your approval.
					</div>
				</div>
				<div className="row panel-row contact-us">
					<div className="col-xs-10 col-xs-offset-1">
						If you have any questions, please do not hesitate to contact us. The RollKall Team,&nbsp;
						<a href="mailto:support@rollkall.com">support@RollKall.com</a>
						&nbsp;
						<a href="tel:+18557655525">(855) 765-5525</a>
					</div>
				</div>
				<div className="row panel-row">
					<a className="btn btn-primary" href="/">Continue to my Business Portal</a>
				</div>
				<div className="row panel-row">
					<small className="col-xs-10 col-xs-offset-1">
						<em>Jobs will not appear in the portal until your request is reviewed by a RollKall Coordinator.</em>
					</small>
				</div>
			</div>
		</div>
	);
};

Confirmation.propTypes = {
	JobEventType : PropTypes.string.isRequired,
};

export default Confirmation;
